export const QUERY_KEYS = {
    CASH_BALANCE: [
        "cash-balance"
    ],
    CASH_PRODUCT_LIST: [
        "cash-product-list"
    ],
    CASH_TRANSACTION_LIST: [
        "cash-transaction-list"
    ],
    POINT_BALANCE: [
        "point-balance"
    ],
    POINT_TRANSACTION_LIST: [
        "point-transaction-list"
    ],
    RECEIPT: [
        "receipt"
    ],
    CASH_RECEIPT: [
        "cash-receipt"
    ],
    NICE_AUTH_DATA: [
        "nice-auth-data"
    ]
};
